import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';
import { getBorderStyle } from './getBorderStyle';

// Form does not provide status prop on error/warning validation just adds correct status-{status} class
// This way element is checked if "status-error"/"status-warning" is present and proper border styling is applied
export const getClassBasedBorder = (): FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
  :has([class*='status-error']),
  :is([class*='status-error']) {
    ${getBorderStyle('error')}
  }

  :has([class*='status-warning']),
  :is([class*='status-warning']) {
    ${getBorderStyle('warning')}
  }

  && * {
    border: none;
    box-shadow: none;
  }
`;
